/**
 * Constants for FileMasterConfigV2 components.
 * Used by StepColumnMappingV2 and StepConfigSummaryV2.
 */

export const DATA_TYPES = [
  { text: 'String', value: 'string' },
  { text: 'Number', value: 'number' },
  { text: 'Date', value: 'date' },
  { text: 'Time', value: 'time' },
];

export const USER_COL_MAP_OPTIONS = [
  { text: 'Company code/name (Combo code)', value: 'company_code' },
  { text: 'Related party code/name (Combo code)', value: 'related_party_code' },
  { text: 'Customer code (FIFO)', value: 'customer_code' },
  { text: 'Customer name (FIFO)', value: 'customer_name' },
  { text: 'Amount to display in summary & reconciliation tab', value: 'amounts' },
  { text: 'Vendor code (FIFO)', value: 'vendor_code' },
  { text: 'Vendor name (FIFO)', value: 'vendor_name' },
  { text: 'Summary combo code (split column)', value: 'summary_combo_code' },
  { text: 'Invoice date', value: 'invoice_date' },
  { text: 'Collection date', value: 'collection_date' },
  { text: 'Reporting amount', value: 'reporting_amount' },
  { text: 'Reporting date', value: 'reporting_date' },
  { text: 'Reporting string', value: 'reporting_string' },
];

export const FILE_STATUS = {
  PENDING: 'pending',
  SUCCESS: 'success',
  ERROR: 'error',
};

export const NULL_MAPPING_DISPLAY = '\u2014'; // em-dash
export const NULL_MAPPING_VALUE = '-';

/**
 * Label validation for columnmap entries.
 * label is the canonical identifier — used as MongoDB document attribute names.
 */
export const LABEL_PATTERN = /^[\w\s\-()/#&,]+$/u;
export const LABEL_MAX_LENGTH = 100;

/**
 * Validate a columnmap label.
 * @param {string} label
 * @returns {{ valid: boolean, message: string }}
 */
export function validateLabel(label) {
  if (!label || typeof label !== 'string' || label.trim().length === 0 || label.length > LABEL_MAX_LENGTH) {
    return { valid: false, message: 'Label must be between 1 and 100 characters' };
  }
  if (label.startsWith('$')) {
    return { valid: false, message: "Label must not start with '$'" };
  }
  if (!LABEL_PATTERN.test(label)) {
    return {
      valid: false,
      message: 'Label contains invalid characters. Only letters, digits, spaces, hyphens, underscores, parentheses, forward slashes, #, &, and commas are allowed',
    };
  }
  return { valid: true, message: '' };
}
